module.exports = __webpack_public_path__ + "static/media/Helvetica.87f1fd48.ttf";